import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import ActivityLogMain from "Components/ActivityLog/ActivityLogMain";
import StaffsMain from "Components/Staff/StaffsMain";
// const StaffsMain = React.lazy(() => import("Components/Staff/StaffsMain"));
// const ActivityLogMain = React.lazy(() =>
//   import("Components/ActivityLog/ActivityLogMain")
// );

const Staffs = () => {
  const query = new URLSearchParams(window.location.search);
  return (
    <>
      {" "}
      {/* <ContainerWrapper> */}
      {"activity".includes(query.get("actionType")) ? (
        <ActivityLogMain />
      ) : (
        <StaffsMain />
      )}{" "}
      {/* </ContainerWrapper> */}
    </>
  );
};

export default Staffs;
